export default "__VITE_ASSET__1cee6cb7__"